import colors from "@constants/color";
export const orderStatusToHindi = (orderStatus = "") => {
  switch (orderStatus.toUpperCase()) {
    case "CANCELLED":
      return "कैंसलड";

    case "PENDING":
      return "प्रोसेसिंग";

    case "FULFILLED":
      return "प्रोसेसिंग";

    case "PARTIALLY_FULFILLED":
      return "प्रोसेसिंग";

    case "PARTIALLY_DISPATCHED":
      return "कुछ आइटम्स निकल गये";

    case "PARTIAL_RTO":
      return "कुछ आइटम्स नहीं लिए";

    case "PARTIALLY_RETURNED":
      return "कुछ आइटम्स वापस कर दिए";

    case "PARTIALLY_DELIVERED":
      return "कुछ आइटम्स डिलीवर्ड हो गए";

    case "NOT_FULFILLED":
      return "नहीं मिले";

    case "DISPATCHED":
      return "निकल गये";

    case "RTO":
      return "नहीं लिए";

    case "RETURNED":
      return "वापस कर दिए";

    case "DELIVERED":
      return "डिलीवर्ड";

    default:
      return orderStatus;
  }
};

export const orderStatusColor = (orderStatusHi = "") => {
  switch (orderStatusHi) {
    // cancelled , rto & returned
    case "कैंसलड":
      return colors.cancelledText;

    case "कुछ आइटम्स नहीं लिए":
      return colors.cancelledText;

    case "नहीं लिए":
      return colors.cancelledText;

    case "कुछ आइटम्स वापस कर दिए":
      return colors.cancelledText;

    case "वापस कर दिए":
      return colors.cancelledText;

    // Pending & fullfilled
    case "पेंडिंग":
      return colors.pendingText;

    case "कुछ आइटम्स मिले":
      return colors.pendingText;

    case "नहीं मिले":
      return colors.pendingText;

    // dispatch
    case "निकल गये":
      return colors.dispatchedText;

    case "कुछ आइटम्स निकल गये":
      return colors.dispatchedText;

    //delivered
    case "कुछ आइटम्स डिलीवर्ड हो गए":
      return colors.deliveredText;

    case "डिलीवर्ड":
      return colors.deliveredText;

    case "प्रोसेसिंग":
      return colors.shakespeare;

    default:
      return colors.black;
  }
};

export const capitalize = ([first, ...rest]) =>
  first.toUpperCase() + rest.join("").toLowerCase();

export const getTrimmedObject = (obj) => {
  let newTrimmedObj = {};

  for (let key in obj) {
    newTrimmedObj[key.trim()] = obj[key].trim();
  }

  return newTrimmedObj;
};

export const passbookHeaderTitle = (type = "") => {
  switch (type) {
    case "bonus":
      return "बोनस कमीशन";

    case "referral":
      return "रेफरल कमीशन";

    case "refund":
      return "रिफंड";

    case "debit":
      return "Debit";

    default:
      return type;
  }
};

export const passbookStatusText = (status = "") => {
  switch (status) {
    case "FAILED":
      return "फेल्ड";

    case "SUCCESSFULL":
      return "सक्सेसफुल";

    case "PROCESSING":
      return "प्रोसेसिंग";

    default:
      return status;
  }
};

export const passbookStatusTextColor = (status = "") => {
  switch (status) {
    case "फेल्ड":
      return colors.internationalOrange;

    case "सक्सेसफुल":
      return colors.mountainMeadow;

    case "प्रोसेसिंग":
      return colors.shakespeare;

    default:
      return colors.black;
  }
};

export const passbookAmountToShow = (type = "") => {
  switch (type) {
    case "bonus":
      return "bonus_amount";

    case "referral":
      return "referral_amount";

    case "refund":
      return "refund_amount";

    case "debit":
      return "debit_amount";
    default:
      return null;
  }
};

export const getScreenName = (routeName = "") => {
  switch (routeName) {
    case "Orders":
      return "Orders";
    case "StaticPages":
      return "About us/Contact us";
    case "AddUser":
      return "Add Customer";
    case "OrderedProducts":
      return "Order Items";
    default:
      return routeName;
  }
};
